<form [formGroup]="form">
  <div class="flex gap-2">
    <div>
        <thera-button
          (click)="topTimeClockClick(isClockedIn ? 'out' : 'in')"
          [config]="{
            variant: buttonVariant.SECONDARY,
            text: ''
          }"
          [iconOnly]="true"
        >
          <img src="/assets/clock-white.svg">
        </thera-button>

      <div class="clock-in-modal" *ngIf="modalVisible">
        <div class="flex">
          <div class="text-dark_blue font-medium">Clock In</div>
          <a
            [routerLink]="['/time-card']"
            class="flex ml-auto text-sm underline flex-wrap content-center font-medium"
            >My Time Card</a
          >
        </div>
        <div class="w-full mt-3">
          <thera-dropdown
            [formGroup]="form"
            (optionSelected)="facilitySelected($event)"
            [isDisabled]="clockInDisabled || isClockedIn"
            [defaultSelection]="this.form.get('facilityId')!.value"
            controlName="facilityId"
            [datasource]="facilities"
          ></thera-dropdown>
        </div>
        <div class="pt-4 bg-[#f8f8f8] mt-5 grid">
          <div class="flex justify-center">
            <mat-form-field appearance="outline" class="form__input--time">
              <input
                type="number"
                (change)="onHourChange($event)"
                (keyup)="onHourChange($event)"
                matInput
                class="w-1/3 pr-5"
                [min]="1"
                [max]="12"
                formControlName="hour"
              />
            </mat-form-field>
            <div class="ml-2 mr-2 flex mt-2">:</div>
            <mat-form-field appearance="outline" class="mr-2 form__input--time">
              <input
                type="number"
                matInput
                (keyup)="onMinuteChange($event)"
                (change)="onMinuteChange($event)"
                class="w-1/3 pr-5 form-control"
                [min]="0"
                [max]="59"
                formControlName="minute"
              />
            </mat-form-field>
            <thera-dropdown
              class="form__input--time"
              (optionSelected)="ampmChangedEvent($event)"
              [options]="[
                { id: 'am', name: 'AM' },
                { id: 'pm', name: 'PM' }
              ]"
              [formGroup]="form"
              [reload$]="reloadAmPm$"
              [controlName]="'ampm'"
              [defaultSelection]="form.get('ampm')!.value"
              [isDisabled]="clockInDisabled"
            ></thera-dropdown>
          </div>
          <div
            class="elapsed-time mb-5"
            [ngClass]="{ disabled: !isClockedIn, 'clocked-in': isClockedIn }"
          >
            {{ !isClockedIn ? 0 : (elapsedHours | async) }}h
            {{ !isClockedIn ? "00" : (elapsedMinutes | async) }}m
          </div>
          <div class="text-center mb-4">
            <thera-button
              class="mr-3"
              [disabled]="clockInDisabled"
              *ngIf="!isClockedIn"
              (click)="!clockInDisabled && toggleTimeClock()"
              [config]="{
                text: 'Clock In',
                variant: buttonVariant.PRIMARY
              }"
            ></thera-button>
            <thera-button
              class="mr-3"
              [disabled]="clockInDisabled"
              *ngIf="isClockedIn"
              (click)="!clockInDisabled && toggleTimeClock()"
              [config]="{
                text: 'Clock Out',
                variant: buttonVariant.PRIMARY_OUTLINE
              }"
            ></thera-button>
          </div>
          <div
            *ngIf="timeClockError"
            class="text-xs text-danger text-center mb-2"
          >
            {{ timeClockError }}
          </div>
          <div *ngIf="errorDate" class="text-xs text-danger text-center mb-2">
            <a (click)="navigateToErrorTimeCard()">{{ errorDate }}</a>
          </div>
          <div
            class="text-center text-xs italic pb-5"
            *ngIf="dayClockIns.length > 0"
          >
            <a
              class="font-medium"
              (click)="allHoursVisible = !allHoursVisible"
              >{{
                allHoursVisible
                  ? "Hide
                            all hours"
                  : "View all
                            hours"
              }}</a
            >
          </div>
        </div>
        <div class="mt-4" *ngIf="allHoursVisible">
          <div
            class="flex flex-row border-b-2 border-b-[black] border-solid pb-2"
          >
            <div
              class="flex flex-col w-full font-semibold text-dark_blue text-xs pl-2"
            >
              Facility
            </div>
            <div
              class="flex flex-col w-full font-semibold text-dark_blue text-xs pr-2"
            >
              Time
            </div>
          </div>
          <div class="clock-ins-row" *ngFor="let row of dayClockIns">
            <div class="flex flex-col w-full pl-2">{{ row.facilityName }}</div>
            <div class="flex flex-col w-full pr-2">
              {{ row.timein | date : "shortTime" }} -
              {{ row.timeout | date : "shortTime" }}
            </div>
          </div>
          <div class="flex flex-row mt-2 bg-matisse text-white p-2 text-sm">
            <div class="flex flex-col w-full">Total Time</div>
            <div class="flex flex-col ml-auto whitespace-nowrap">
              {{ allHoursTotalTime.hour }}h {{ allHoursTotalTime.minute }}m
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
